import React, { useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { useSelector, useDispatch } from 'react-redux'
import { requestGeolocation, searchLocation } from './locationActions'
import { selectUserWeatherLocations } from '../../selectors/userSelector'
import * as keyCodes from '../../lib/keyCodes'
import Loading from '../util/Loading'
import Star from '../../views/Weather/icons/star'

const LocationSearchDialog = ({ onLocationSelect, onFavoriteClick }) => {
  const dispatch = useDispatch()
  const results = useSelector(state => state.location.get('searchResults'))
  const loading = useSelector(state => state.location.get('geoLocationLoading'))
  const searchString = useSelector(state => state.location.get('searchString'))
  const userLocations = useSelector(selectUserWeatherLocations)

  const [arrowSelectionIndex, setArrowSelectionIndex] = useState(0)

  const handleKeyDown = (event) => {
    if (event.keyCode === keyCodes.enter) {
      onLocationSelect(results.get(arrowSelectionIndex))
    } else if (event.keyCode === keyCodes.upArrow && arrowSelectionIndex > 0) {
      event.preventDefault()
      setArrowSelectionIndex(arrowSelectionIndex - 1)
    } else if (event.keyCode === keyCodes.downArrow && arrowSelectionIndex < results.size - 1) {
      event.preventDefault()
      setArrowSelectionIndex(arrowSelectionIndex + 1)
    }
  }

  const handleInputChange = (event) => {
    dispatch(searchLocation(event.target.value ?? ''))
    setArrowSelectionIndex(0)
  }

  const handleInputClear = () => {
    dispatch(searchLocation(''))
    setArrowSelectionIndex(0)
  }

  const handleResultClick = (event) => {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    onLocationSelect(results.get(index))
  }

  const handleGeolocationClick = () => {
    dispatch(requestGeolocation())
  }

  return (
    <div className='location-search-dialog'>
      <div className='location-search-dialog__search-container'>
        <input
          className='location-search-dialog__input'
          type='text'
          onChange={ handleInputChange }
          onKeyDown={ handleKeyDown }
          value={ searchString }
          placeholder='Hae kaupunki'
          aria-label='Hae kaupunki'
        />
        { results.size > 0 && (
          <button
            className='location-search-dialog__clear-button'
            onClick={ handleInputClear }
            aria-label='Clear input'
          >
            &times;
          </button>
        ) }
        { results.size > 0 ?
          <div className='location-search-dialog__results'>
            { results.slice(0, 6).map((result, i) => (
              <div className='location-search-dialog__results-location' key={ result.id }>
                <button
                  data-index={ i }
                  onClick={ handleResultClick }
                  className={ classNames('location-search-dialog__results-location-name', { active: i === arrowSelectionIndex }) }
                  aria-label='Valitse sijainti'
                >
                  { result.name }
                </button>
                <button
                  type='button'
                  className='weather-favorite-locations__current-location-button'
                  onClick={ onFavoriteClick }
                  data-location-id={ result.id }
                  data-location-slug={ result.slug }
                  aria-label='Lisää suosikkeihin'
                >
                  <Star
                    className={ classNames('location-search-dialog__results-location-favorite', { 'active': userLocations.some(loc => loc.get('id') === result.id) } ) }
                  />
                </button>
              </div>
            )) }
          </div> : null }
      </div>

      <div className='location-search-dialog__geolocation'>
        <Loading loading={ loading }>
          <button
            type='button'
            className='weather-add-geolocation'
            onClick={ handleGeolocationClick }
            aria-label='Paikanna sijainti'
            title='Paikanna sijainti'
          >
            <svg
              className='weather-add-geolocation__icon'
              xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 43 43'
              fill='none'
            >
              <rect width='40' height='40' rx='4' fill='none' />
              <path d='M20.5412 34.2089C12.9773 23.005 11.5732 21.8551 11.5732 17.7375C11.5732 12.0973 16.0482 7.52502 21.5685 7.52502C27.0887 7.52502 31.5637 12.0973 31.5637 17.7375C31.5637 21.8551 30.1597 23.005 22.5957 34.2089C22.0993 34.9415 21.0376 34.9415 20.5412 34.2089ZM21.5685 21.9927C23.8686 21.9927 25.7331 20.0876 25.7331 17.7375C25.7331 15.3874 23.8686 13.4823 21.5685 13.4823C19.2684 13.4823 17.4038 15.3874 17.4038 17.7375C17.4038 20.0876 19.2684 21.9927 21.5685 21.9927Z' fill='white' />
            </svg>
          </button>
        </Loading>
      </div>
    </div>
  )
}

LocationSearchDialog.propTypes = exact({
  onLocationSelect: PropTypes.func.isRequired,
  onFavoriteClick: PropTypes.func.isRequired,
})

export default LocationSearchDialog
